import CampaignStatus from "@/models/Campaigns/CampaignStatus";

export default class SearchCampaignsRequest {
    status: CampaignStatus[] = [CampaignStatus.Active];
    branchId: string;
    deskId: string;
    ownerId: string;
    emailTemplateId: string;
}